import { components } from 'react-select';

import Icon from 'components/shared/Icon/Icon';

const CategoryOption = ({ onDelete, ...props }) => (
  <components.Option {...props}>
    {props?.data?.__isNew__ ? (
      <div className="flex cursor-pointer items-center gap-3 text-left text-sm text-neutral-800 hover:bg-primary-50">
        <Icon icon="add-circle-mono" size={24} color="primary"></Icon>
        {props?.data?.value}
      </div>
    ) : (
      <div className="flex w-full justify-between gap-3">
        {props?.data?.label}
        <button
          className="cursor-pointer"
          aria-label={`Delete ${props.data.label} category`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(props.data);
          }}>
          <Icon className="cursor-pointer" icon="trash-mono" color="danger"></Icon>
        </button>
      </div>
    )}
  </components.Option>
);

export default CategoryOption;
